export enum LoadingState {
  IDLE,
  FAILED,
  LOADING,
  DONE,
}
